import { render } from "./Navbar.vue?vue&type=template&id=0d35b122&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=0d35b122&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=0d35b122&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d35b122"]])

export default __exports__